/**
 * Consent Routes (OAuth Flow)
 */
export default [
    {
        path: '/consent',
        name: 'consent',
        component: () => import('../../pages/consent/IndexPage.vue'),
        meta: {
            layout: 'consent',
            requiresAuth: true,
            title: 'Consent',
        },
        props: (route) => ({
            returnUrl: route.query.ReturnUrl,
        }),
    },
    {
        // PROXY_ADMIN EMAIL_LINK / UNIQUE_URL — 본인 canvas 서명 페이지 (외부 링크 진입, 로그인 불필요)
        path: '/consent/sign/:token',
        name: 'consentSign',
        component: () => import('../../pages/consent/SignPage.vue'),
        meta: {
            layout: 'auth',
            requiresAuth: false,
            title: 'Consent Sign',
        },
        props: true,
    },
];
